import React, { ComponentProps } from 'react';

import PropTypes from 'prop-types';
import { CSSObject, ThemeProvider } from 'styled-components';

import {
  ThemeTypography,
  useTheme,
  type LegacyPalette,
} from '@adsk/alloy-react-styles';
import theme from '@adsk/alloy-react-theme';

import { useLegacyPalette } from './hooks/useLegacyPalette';

export type Colors = keyof NonNullable<LegacyPalette>;
export type Typography = keyof ThemeTypography;
export type Ellipsis = 'single' | 'multi';

export const propTypes = {
  color: {
    bg: PropTypes.oneOf(Object.keys(theme.colors)),
    color: PropTypes.oneOf(Object.keys(theme.colors)),
  },
  typography: {
    typography: PropTypes.oneOf(Object.keys(theme.typography)),
  },
  ellipsis: {
    ellipsis: PropTypes.oneOf(['single', 'multi']),
  },
};

export const base = {
  boxSizing: 'border-box',
  margin: 0,
  minWidth: 0,
} as CSSObject;

const Theme: React.FC<Omit<ComponentProps<typeof ThemeProvider>, 'theme'>> = ({
  children,
}) => {
  const dynamicTheme = useTheme();
  const colors = useLegacyPalette();

  const config = React.useMemo(
    () => ({
      breakpoints: ['40em', '52em', '64em'],
      fontSizes: [12, 14, 16, 24, 32, 48, 64, 96, 128],
      space: [0, 4, 8, 16, 12, 24, 32, 48],
      colors,
      typography: dynamicTheme?.tokens?.component?.typography,
    }),
    [colors, dynamicTheme],
  );

  return <ThemeProvider theme={config}>{children}</ThemeProvider>;
};

export default Theme;
